
import { format, parseISO } from 'date-fns'
import { pathOr } from 'ramda'
import CardWrapper from '../../../../shared/CardWrapper'

export default {
  name: 'CourseOfferItem',
  components: { CardWrapper },
  props: {
    details: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    time() {
      const { start, end } = this.details
      if (!start) {
        return ''
      }
      return `${format(parseISO(start), 'HH:mm')} - ${format(
        parseISO(end),
        'HH:mm'
      )}`
    },
    price() {
      return pathOr('', ['price'], this.details)
    },
    capacity() {
      const { students, capacity } = this.details
      return `${students}/${capacity}`
    },
  },
}
